import {platformAppName} from '@telstra-connect/utils/data/platform-data'
import {FeatureFlagsHelper} from '@telstra-connect/feature-flags'
import {IFeatureFlags, IDashboardFlags} from './common'
import dashboardFeatureFlags from './flags'

let helper: FeatureFlagsHelper<typeof platformAppName>

export const loadFeatureFlags = (getFlagsConfigFromState?: () => IDashboardFlags) => {
  helper = new FeatureFlagsHelper(platformAppName, getFlagsConfigFromState, dashboardFeatureFlags)
}

export const getDashboardFlags: () => IFeatureFlags = () => helper && helper.getFlags()
